import { NewsList } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetNewsListResponse } from "../schema/GetNewsListResponse";
import { mapNewsList } from "../../mappers/news/newsListMapped";

export const getNewsList = async (p0?: { page: string; }): Promise<NewsList> => {
    const client = ApiClient.getInstance()

    const params = new URLSearchParams()

    if (p0?.page) params.append('page', p0.page);

    const response = await client.get<GetNewsListResponse>(`news/categoriesList?${params.toString()}`)

    const mappedResponse = mapNewsList(response.data)

    return mappedResponse;
}